(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/race-history.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/race-history.js');

'use strict';

const {
  useState,
  useCallback
} = React;
const {
  EmptyDataView
} = svs.racing.emptyDataView;
const {
  Skeleton
} = svs.components.lbUi;
const {
  getStatisticsNoDataMsg
} = svs.racing.common.strings;
const {
  statisticsService,
  statistics
} = svs.racing_game.components;
const {
  RaceHistoryItem
} = svs.racing_game.components.statistics;
const {
  SwipeArrows
} = svs.sport.swipeArrows;
const {
  ReactIcon,
  ReactIconButton
} = svs.ui;
const {
  dialog
} = svs.components;
const getScrollWidth = direction => {
  const historyContent = document.querySelector('.race-history-holder');
  const scrollWidth = historyContent.scrollWidth;
  return direction === 'right' ? scrollWidth : 0;
};
const handleHelpButtonClick = event => {
  let title = '';
  const texts = [];
  title = 'Avstånd till framförvarande häst';
  texts.push(['CTT = Kort huvud', 'DH = Dött lopp', 'ENC = Hals', 'NEZ = Nos', 'T = Huvud', 'L = Hästlängd', 'CTE = Kort nacke', 'LON = Distanserad'].filter(Boolean).join('<br />'));
  const contextDialog = new dialog.Contextual({
    branding: dialog.branding.SPORT,
    attachTo: event.currentTarget,
    zIndex: 1100,
    title,
    message: texts.map(text => ({
      text,
      type: dialog.message.TEXT
    }))
  });
  dialog.api.add(contextDialog);
};
const RaceHistory = _ref => {
  let {
    participantId
  } = _ref;
  const [data, error, isLoading] = statistics.useStatisticsData(participantId, statisticsService.fetchLastPerformance);
  const [historyHolderEl, setHistoryHolderEl] = useState(null);
  const historyHolderRef = useCallback(node => {
    if (node !== null) {
      setHistoryHolderEl(node);
    }
  }, []);
  if (isLoading) {
    return React.createElement(Skeleton, {
      height: 1,
      numLines: 10
    });
  }
  if (error) {
    return React.createElement("div", {
      className: "statistics-no-data"
    }, React.createElement(EmptyDataView, {
      label: getStatisticsNoDataMsg()
    }));
  }
  return React.createElement("div", {
    className: "race-history"
  }, React.createElement(SwipeArrows, {
    containerClassName: "race-history-arrow-container",
    getLeftScrollWidth: () => getScrollWidth('left'),
    getRightScrollWidth: () => getScrollWidth('right'),
    scrollContentEl: historyHolderEl
  }), React.createElement("div", {
    className: "race-history-holder",
    ref: historyHolderRef
  }, React.createElement("div", {
    className: "race-history-list"
  }, React.createElement("div", {
    className: "race-history-list-items fc-racing-900"
  }, React.createElement("div", {
    className: "race-history-row race-history-header"
  }, React.createElement("div", {
    className: "horse-history-column drop-down"
  }), React.createElement("div", {
    className: "horse-history-column horse-info"
  }, "Datum"), React.createElement("div", {
    className: "horse-history-column vod-holder"
  }, "Video"), React.createElement("div", {
    className: "horse-history-column finish-place ".concat(data[0].participants[0].trotting ? 'trotting' : 'gallop')
  }, data[0].participants[0].trotting ? 'Plac.' : 'Plac.-Avs.', data[0].participants[0].gallop && React.createElement("div", {
    className: "race-history-placement-explanation"
  }, React.createElement(ReactIconButton, {
    className: "icon-button padding-xs-h race-history-help-btn",
    onClick: handleHelpButtonClick
  }, React.createElement(ReactIcon, {
    color: "fc-sport",
    icon: "help",
    size: "300"
  })))), React.createElement("div", {
    className: "horse-history-column race-distance"
  }, "Distans (m)"), React.createElement("div", {
    className: "horse-history-column race-dicipline"
  }, "Disciplin"), data[0].participants[0].gallop && React.createElement("div", {
    className: "horse-history-column start-gate"
  }, "Startbox"), React.createElement("div", {
    className: "horse-history-column ".concat(data[0].participants[0].trotting ? 'kilometer-time' : 'riders-weight')
  }, data[0].participants[0].trotting ? 'Tid' : 'Ridvikt (kg)'), React.createElement("div", {
    className: "horse-history-column prize-money"
  }, "1:a pris")), data.map(race => React.createElement(RaceHistoryItem, {
    key: "".concat(race.date, "_").concat(race.raceId, "_").concat(participantId),
    race: race
  })))), React.createElement("div", {
    className: "race-history-no-data margin-v-2"
  }, getStatisticsNoDataMsg())));
};
svs.racing_game.components.statistics.RaceHistory = RaceHistory;

 })(window);